import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import errorsType from "../types/errorsType";
import tooltips from "./tooltips";
import {
  SectionTitle,
  Field,
  Label,
  LabelText,
  LabelIcon,
  Input,
  Required,
  Select,
  Option,
  Error,
} from "../styles/edit-form-styles";

library.add(faInfoCircle);

const Interview = (props) => {
  const {
    interviewComments,
    interviewStages,
    feedbackTimescaleId,
    feedbackTimescaleOptions,
    cvLimitPerRecruiter,
    inputOnChange,
    feedbackTimescaleOnChange,
    errors,
  } = props;

  // 1 to 20, plus 1 for the 'Unlimited' option
  const numberOfSelectOptions = 21;
  const cvLimits = Array.from(Array(numberOfSelectOptions).keys()).map(
    (value) => {
      const isUnlimited = value === 0;
      return {
        text: isUnlimited ? "Unlimited" : value,
        value,
      };
    }
  );

  const stages = [1, 2, 3];

  return (
    <Fragment>
      <SectionTitle>Interview</SectionTitle>
      <Field>
        <Label htmlFor="feedback-timescale">
          <LabelText>
            Feedback Timescale <Required>*</Required>
          </LabelText>
        </Label>
        <Select
          error={!!errors.feedback_timescale}
          onChange={feedbackTimescaleOnChange}
          name="feedbackTimescaleId"
          id="feedback-timescale"
          value={feedbackTimescaleId}
          title="Please select a feedback timescale..."
        >
          <Option value="">Please select a feedback timescale...</Option>
          {feedbackTimescaleOptions.map((feedbackTimescaleOption) => (
            <Option
              key={feedbackTimescaleOption.id}
              value={feedbackTimescaleOption.id}
            >
              {feedbackTimescaleOption.name}
            </Option>
          ))}
        </Select>
        {errors.feedback_timescale && (
          <Error>Please select a feedback timescale.</Error>
        )}
      </Field>
      <Label htmlFor="cv-limit">Number of Interview Stages</Label>
      <Select
        onChange={inputOnChange}
        id="interview-stages"
        title="Please select a number of stages..."
        name="interviewStages"
        value={interviewStages}
      >
        {stages.map((stage) => (
          <Option key={stage} value={stage}>
            {stage}
          </Option>
        ))}
      </Select>
      <Label htmlFor="interview-comments">
        <LabelText>Interview Comments</LabelText>
        <LabelIcon>
          <FontAwesomeIcon
            data-tip={tooltips.interviewComments}
            data-for="interview-comments-tooltip"
            icon="info-circle"
          />
          <ReactTooltip
            place="left"
            type="dark"
            effect="solid"
            aria-haspopup="true"
            id="interview-comments-tooltip"
          />
        </LabelIcon>
      </Label>
      <Input
        type="text"
        name="interviewComments"
        id="interview-comments"
        value={interviewComments}
        onChange={inputOnChange}
      />
      <Field>
        <Label htmlFor="cv-limit">
          <LabelText>
            CV Limit Per Recruiter <Required>*</Required>
          </LabelText>
        </Label>
        <Select
          error={!!errors.cv_limit_per_recruiter}
          onChange={inputOnChange}
          id="cv-limit"
          title="Please select a CV limit..."
          name="cvLimitPerRecruiter"
          value={cvLimitPerRecruiter}
        >
          <Option value="">Please select a CV limit...</Option>
          {cvLimits.map((cvLimit) => (
            <Option key={cvLimit.value} value={cvLimit.value}>
              {cvLimit.text}
            </Option>
          ))}
        </Select>
        {errors.cv_limit_per_recruiter && (
          <Error>CV Limit cannot be blank</Error>
        )}
      </Field>
    </Fragment>
  );
};

Interview.propTypes = {
  feedbackTimescaleOnChange: PropTypes.func.isRequired,
  inputOnChange: PropTypes.func.isRequired,
  interviewComments: PropTypes.string.isRequired,
  interviewStages: PropTypes.number.isRequired,
  feedbackTimescaleId: PropTypes.number.isRequired,
  feedbackTimescaleOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ).isRequired,
  cvLimitPerRecruiter: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  errors: errorsType.isRequired,
};

export default Interview;
